import { Controller } from "@hotwired/stimulus";
import CableReady from 'cable_ready';
import consumer from '../channels/consumer';

export default class extends Controller {
  connect() {
    consumer.subscriptions.create({
      channel: 'SalesOrderChannel',
      id: this.context.element.dataset.id
    }, {
      received(data) {
        if (data.cableReady) CableReady.perform(data.operations)
      }
    })
  }
}
